import { Injectable } from '@angular/core';
import { FantasyLeaderboard } from './models/fantasy-leaderboard.model';
import { StoreConfig, Store } from '@datorama/akita';

export interface FantasyLeaderboardState {
  monthlyLeaderboard: FantasyLeaderboard[];
  yearlyLeaderboard: FantasyLeaderboard[];
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'FantasyLeaderboard'})
export class FantasyLeaderboardStore extends Store<FantasyLeaderboardState> {
  constructor() {
    super({});
  }
}

